import { Home as HomeIcon, Sparkles } from "lucide-react";

/**
 * BrandedLoader — the on-brand "plan your next experience" loading state.
 * Used wherever we fetch data and the page would otherwise flash a bare
 * "Loading…" string. The gentle pulse animation (CSS transform + opacity)
 * runs on the GPU so it doesn't compete with the network request for CPU.
 *
 * Variants:
 *   - page: full-viewport, centered, for route-level fallbacks.
 *   - inline: compact, for tab-level or card-level placeholders.
 */
export default function BrandedLoader({ variant = "page", message }) {
  const body = (
    <div className="flex flex-col items-center gap-4 text-center">
      <div className="relative h-14 w-14">
        <span className="absolute inset-0 rounded-full border-2 border-gold/30 animate-ping" />
        <span className="absolute inset-0 flex items-center justify-center rounded-full border border-forest/15 bg-parchment">
          <HomeIcon size={22} className="text-forest" strokeWidth={1.5} />
        </span>
      </div>
      <div>
        <p className="font-accent text-xs uppercase tracking-[0.25em] text-gold flex items-center justify-center gap-1.5">
          <Sparkles size={12} /> Vyagram
        </p>
        <p className="mt-1 font-display text-lg text-forest">{message || "Planning your next experience…"}</p>
      </div>
    </div>
  );
  if (variant === "inline") {
    return <div className="flex items-center justify-center py-12" data-testid="branded-loader-inline">{body}</div>;
  }
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4 py-24" data-testid="branded-loader">
      {body}
    </div>
  );
}
